export type FarmRewardState = 'running' | 'notStarted' | 'ended'

/**
 * Whether a V3 farm pays CBON right now. MasterChefV3 keeps `latestPeriodCadinuPerSecond` after a period ends, so the
 * page must not turn it into an APR then. A farm whose LM pool never accrued a reward (rewardGrowthGlobalX128 = 0) has
 * not started; one that did, and has no running period or no allocation any more, has ended.
 */
export const getFarmRewardState = ({
  rewardsRunning,
  rewardGrowthGlobalX128,
  multiplier,
}: {
  rewardsRunning?: boolean
  rewardGrowthGlobalX128?: string
  multiplier?: string
}): FarmRewardState => {
  const accrued = Boolean(rewardGrowthGlobalX128) && rewardGrowthGlobalX128 !== '0'
  if (multiplier === '0X') return accrued ? 'ended' : 'notStarted'
  if (rewardsRunning === false) return accrued ? 'ended' : 'notStarted'
  return 'running'
}
